"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingCheckBalanceButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const dialogs_1 = require("../../../../dialogs");
const StakingCheckBalanceButton = (props) => {
    const { className, contract, contract: { id, address }, disabled, variant, } = props;
    const { openViewDialog } = (0, dialogs_1.useGlobalDialogViewCallbacks)();
    const handleCheckBalance = () => {
        openViewDialog(dialogs_1.GlobalDialogKeys.STAKING_CHECK_BALANCE, contract, {
            message: "dialogs.checkBalance.title",
            componentProps: {
                data: { id, address, contract },
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleCheckBalance, icon: icons_material_1.PriceCheck, message: "form.buttons.checkBalance", className: className, dataTestId: "CheckBalanceButton", disabled: disabled, variant: variant }));
};
exports.StakingCheckBalanceButton = StakingCheckBalanceButton;
//# sourceMappingURL=index.js.map